import { FileClient, PageableResponse, RestClient } from "clients/rest";

export type B090050FindRequest = {
  torihikiYmdFrom: string;
  torihikiYmdTo: string;
  sokoCd: string;
  shohinCd: string;
} & Partial<{
  janCd: string;
  updDateFrom: string;
  updhourFrom: string;
  updminuteFrom: string;
  updDateTo: string;
  updhourTo: string;
  updminuteTo: string;
  updshainCd: string;
  ukeharaiKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B090050FindResponse = {
  crtDate: string;
  ukeharaiKbnNm: string;
  ukeiresu: string;
  haraidashisu: string;
  hikiatesu: string;
  // denpyoNo: string;
  torihikiCd: string;
  torihikishitenCd: string;
  torihikiNmr: string;
  torihikiYmdView: string;
  aitesakisokoCd: string;
  aitesakisokoNm: string;
  shainNm: string;
};

//検索処理
export const B090050Find = (props: B090050FindRequest) => {
  return RestClient.get<PageableResponse<B090050FindResponse[]>>(
    "b090050/find",
    {
      params: props,
    }
  );
};

//Excel出力処理
export const B090050GetExcel = (props: B090050FindRequest) => {
  return FileClient.get("b090050/get/excel", {
    params: props,
  });
};
